<template>
    <div class="overHeadParamSet">
       <el-form ref="form" label-width="100px" class="attr_common" label-position="left">
            <el-form-item label="方案名称:">
                <el-input v-model="curSuggestion.name" class="input-box" :disabled="!updateFlag"></el-input>
            </el-form-item>
            <el-form-item label="空气温度:">
                <el-input v-model="curSuggestion.airTempe" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">℃</span>
            </el-form-item>
            <el-form-item label="空气流速:">
                <el-input v-model="curSuggestion.airVelocity" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">m/s</span>
            </el-form-item>

        </el-form>

        <!--架空方案设置-->
        <el-table
            :data="suggestions"
            border
            style="width: 100%"
            class="custom-table"
            max-height="300"
            highlight-current-row
            row-class-name="custom-row"
            cell-class-name="custom-cell"
            header-row-class-name="custom-header"
            @current-change="suggestionChange"
            ref="suggestionsTable">

            <el-table-column
                prop="id"
                width="50"
                label="编号">
            </el-table-column>
            <el-table-column
                prop="name"
                label="方案名称">
            </el-table-column>
            <el-table-column
                prop="airTempe"
                label="空气温度">
            </el-table-column>
            <el-table-column
                prop="airVelocity"
                label="空气湿度">
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <el-button @click="defaultSuggestion(scope.row)" type="text" size="small" v-if="defaultSug.id!=scope.row.id">设为默认</el-button>
                    <span v-else>默认</span>
                </template>
            </el-table-column>
        </el-table>

        <div class="foot-btn">
            <el-button size="medium" type="primary" @click="addSuggestion" v-if="!updateFlag">新增</el-button>
            <el-button size="medium" type="primary" @click="updateSuggestion" v-if="!updateFlag">修改</el-button>
            <el-button size="medium" type="primary" @click="deleteSuggestion" v-if="!updateFlag&&this.suggestions.length>1">删除</el-button>
            <el-button size="medium" type="primary" @click="saveSuggestion" v-if="updateFlag">保存</el-button>
            <el-button size="medium" type="primary" @click="cancelSuggestion" v-if="updateFlag">取消</el-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import _remove from "lodash/remove";
import _find from "lodash/find";

export default {
    name:"overHeadParamSet",
    computed:{
        ...mapState('simulation',[
            'globalConfig',
        ])
    },
    data(){
        return {
            curSuggestion:{
                id:0,
                name:"默认方案",
                airTempe:20, // 空气温度
                airVelocity:3, // 空气湿度
            }, // 当前属性


            suggestions:[{
                id:0,
                name:"默认方案",
                airTempe:20, // 空气温度
                airVelocity:3, // 空气湿度
            }], // 可选方案
            
            defaultSug:{}, // 默认方案
            updateFlag:false, // 是否可以编辑
        }
    },
    mounted(){
        this.init_data();
    },
    methods:{
        // 初始化数据
        init_data(){
            if(this.globalConfig){
                if(this.globalConfig.overHeadParamSugs){
                    this.suggestions=JSON.parse(JSON.stringify(this.globalConfig.overHeadParamSugs));
                }
                let environParam=this.globalConfig.pipeModel.environParam;
                if(environParam){
                    this.defaultSug=environParam; // 默认方案
                    this.curSuggestion=JSON.parse(JSON.stringify(this.defaultSug));
                }
            }
        },
        // 新增
        addSuggestion(){
            let suglength=this.suggestions.length;
            let id=this.suggestions[suglength-1].id+1;
            this.curSuggestion={
                id:id,
                name:"默认材料"+id, // 保温材料名称
                airTempe:20, // 空气温度
                airVelocity:3, // 空气湿度
            }
            this.updateFlag=true;
        },
        // 更新
        updateSuggestion(){
            this.updateFlag=true;
        },
        // 取消保存
        cancelSuggestion(){
            let currentId=this.curSuggestion.id;
            let temp=_find(this.suggestions, function(o) { return o.id == currentId; });
            if(!temp){
                temp=this.suggestions[0];
            }
            this.curSuggestion=JSON.parse(JSON.stringify(temp));
            this.updateFlag=false;
        },

        // 保存方案
        saveSuggestion(){
            let temp=null;
            this.suggestions.forEach((item,index)=>{
                if(item.id == this.curSuggestion.id){
                    item=JSON.parse(JSON.stringify(this.curSuggestion));
                    temp=item;
                    this.$set(this.suggestions,index,item); // 更新表格
                }
            });
            // 如果存在该类型的材料，则更新，否则新增
            if(!temp){
                temp=JSON.parse(JSON.stringify(this.curSuggestion));
                this.suggestions.push(temp);
            }
            // 关闭修改
            this.updateFlag=false;

            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(temp);

            // 触发父元素数组更新
            this.globalSuggestionChange();
            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });
        },
        // 方案选中改变
        suggestionChange(item){
            item=item||this.suggestions[0];
            this.curSuggestion=JSON.parse(JSON.stringify(item));
        },
        // 删除方案
        deleteSuggestion(){
            let id=this.curSuggestion.id;
            this.suggestions=_remove(this.suggestions, function(it) {  return it.id!=id;});
            // 恢复默认
            this.curSuggestion=JSON.parse(JSON.stringify(this.suggestions[0]));
            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(this.suggestions[0]);
            // 停止更新
            this.updateFlag=false;
        },
        // 设为默认方案
        defaultSuggestion(item){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            this.defaultSug=item;
            temp.pipeModel.environParam=item;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        },

        // 全局方案修改
        globalSuggestionChange(){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            temp.overHeadParamSugs=this.suggestions;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        },
    }
}
</script>

<style lang="scss" scoped>
.overHeadParamSet{
    width: 600px!important;

    .attr_common{
        display: flex;
        flex-wrap: wrap;

        ::v-deep .el-form-item{
            width: 50%;
            margin-right: 0;

            .el-input{
                width: 120px;
            }
        }
    }

    .foot-btn{
        margin-top: 10px;
    }
}
</style>